import axios from "axios";

const InstanceSchool = axios.create({
    baseURL: "https://f8vjq1w6s8.execute-api.us-west-2.amazonaws.com/dev/",
    headers: {
        "x-api-key": "tu-api-key-aqui"
    }
})


export default InstanceSchool;